export enum CategoryTypeEnum {
  SingleSelect = 0,
  MultiSelect = 1
}

export interface CategoryAsset {
  label: string;
  type: CategoryTypeEnum;
  required: boolean;
}

export interface CategoryAttributes {
  position: number;
  assets: CategoryAsset;
}
